import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { ReduxState } from 'redux/store';
import { GetVendorsParams } from './vendorsParams';

interface Vendor {
  dataAreaId: string;
  vendorAccountNumber: string;
  vendorName: string;
  vendorSearchName: string;
}

interface VendorResponse {
  totalCount: number;
  data: Vendor[];
}

/* ******************** Base Query ******************** */
const baseUrl = process.env.REACT_APP_SIMON_SOUNDMAN_BASE_URL;
const functionsKey = process.env.REACT_APP_API_HOST_KEY_SIMON_SOUNDMAN;

export const simonSoundmanBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as ReduxState).app.accessToken;

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
      headers.set('x-functions-key', functionsKey);
      headers.set('Content-Type', 'application/json');
    }

    return headers;
  }
});

export const simonSoundmanApi = createApi({
  reducerPath: 'simonSoundmanApi',
  baseQuery: simonSoundmanBaseQuery,
  endpoints: (builder) => ({
    getVendors: builder.query<VendorResponse, GetVendorsParams>({
      query: (params) => ({
        url: 'vendors',
        params
      })
    })
  })
});

export const { useGetVendorsQuery, useLazyGetVendorsQuery } = simonSoundmanApi;
